// Typed client for the Xpedition2 API. Paths and bodies come from src/api/schema.ts (generated), so a
// change to the API's contract shows up here as a type error.
import createClient, { type Middleware } from 'openapi-fetch';
import { config } from '@/config';
import type { paths } from './schema';

// The current access token. AuthProvider keeps this up to date as tokens are issued and renewed.
let currentToken: string | undefined;

export function setAccessToken(token: string | undefined) {
  currentToken = token;
}

const bearer: Middleware = {
  onRequest({ request }) {
    if (currentToken) request.headers.set('Authorization', `Bearer ${currentToken}`);
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: config.apiUrl });
api.use(bearer);

/** A plain fetch against the API with the access token, for binary bodies the typed client doesn't cover. */
export function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (currentToken) headers.set('Authorization', `Bearer ${currentToken}`);
  return fetch(`${config.apiUrl.replace(/\/$/, '')}${path}`, { ...init, headers });
}
